import {
  UnitOfMeasurement,
  UnitOfMeasurementCode,
} from 'constants/unitOfMeasurement';
import { UnitsOfMeasurementModelType } from 'interfaces/unitOfMeasurement';

export const SALE_MAPPING: UnitsOfMeasurementModelType[] = [
  {
    key: 'sf',
    config: {
      [UnitOfMeasurementCode.US]: {
        field: 'sf',
        unit: UnitOfMeasurement.sf,
      },
      [UnitOfMeasurementCode.UK]: {
        field: 'sf',
        unit: UnitOfMeasurement.sf,
      },
      [UnitOfMeasurementCode.EU]: {
        field: 'squareMeters',
        unit: UnitOfMeasurement.sm,
      },
    },
  },
];
